export const GET_PENDING_PAYMENT_REQUEST_LIST_ERROR =
  'GET_PENDING_PAYMENT_REQUEST_LIST_ERROR';
export const GET_PENDING_PAYMENT_REQUEST_LIST_START =
  'GET_PENDING_PAYMENT_REQUEST_LIST_START';
export const GET_PENDING_PAYMENT_REQUEST_LIST_SUCCESS =
  'GET_PENDING_PAYMENT_REQUEST_LIST_SUCCESS';
